<nb-select #selector [multiple]="multi" [(ngModel)]="selectedKey" fullWidth="true" (ngModelChange)="selectionChange($event)" >
  <nb-option *ngFor="let item of itemsSource" [value]="getId(item)">{{this.getValue(item)}}</nb-option>
</nb-select>
